import { createAction, createSlice } from '@reduxjs/toolkit';
import { Coin } from './types';

export interface State {
  avatar: string | null;
  twitterHandle: string | null;
  coins: Coin[];
  selectedCoin: Coin;
  fetched: {
    info: boolean;
    coin: boolean;
  };
}

export const initialState: State = {
  avatar: null,
  twitterHandle: null,
  coins: [],
  selectedCoin: {} as Coin,
  fetched: {
    info: false,
    coin: false,
  },
};

const TokenTeam = createSlice({
  name: 'tokenTeam',
  initialState,
  reducers: {
    fetchInfoSuccess(state, { payload }) {
      const { avatar, twitterHandle, coins } = payload;
      state.avatar = avatar;
      state.twitterHandle = twitterHandle;
      state.coins = coins;
      state.selectedCoin = {
        ...state.selectedCoin,
        code: state.selectedCoin.code || coins[0].code,
      };
      state.fetched = {
        ...state.fetched,
        info: true,
      };
    },
    selectCoin(state, { payload }) {
      state.selectedCoin = {
        ...state.selectedCoin,
        code: payload,
      };
    },
    fetchCoinInfoSuccess(state, { payload }) {
      state.selectedCoin = {
        ...state.selectedCoin,
        ...payload,
      };
      state.fetched = {
        ...state.fetched,
        coin: true,
      };
    },
  },
});

// Export slice actions
export const {
  fetchCoinInfoSuccess,
  fetchInfoSuccess,
  selectCoin,
} = TokenTeam.actions;

// Export custom saga actions
export const fetchInfo = createAction('FETCH_INFO');
export const fetchCoinInfo = createAction('FETCH_COIN_INFO');

export default TokenTeam.reducer;
